/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Inject, Injectable } from '@angular/core';
import { AvatarService } from '@ng-falcon/features/avatar/avatar.service';

@Injectable({
  providedIn: 'root',
})
export class UtAvatarService implements AvatarService {
  private avatarUrlCache = new Map<number, string>();

  constructor(@Inject('UserService') private userService: any) {
    this.userService.me().then((res: any) => {
      if (res?.data?.platform_id && res?.data?.avatar_url) {
        this.avatarUrlCache.set(res.data.platform_id, res.data.avatar_url);
      }
    });
  }

  generateAvatarUrl(userId: number, _useStoredUrlIfCurrentUser: boolean): string {
    return this.avatarUrlCache.get(userId) ?? '';
  }
}
